/* CabGear: hide Shopify Inbox during Zepto popup personalization. */
(function () {
  'use strict';
  var className = 'cg-zepto-customizer-open';
  var modalSelector = '.pplr-popup.pplr-modal-box';
  var openSelector = '.pplr-c-button.ptc_button';
  var closeSelector = '.pplr_close';
  var manualOpen = false;
  var queued = false;
  function visible(node) {
    if (!node || node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
    var style = getComputedStyle(node);
    return style.display !== 'none' && style.visibility !== 'hidden' && node.getClientRects().length > 0;
  }
  function update() {
    queued = false;
    var modal = document.querySelector(modalSelector);
    document.documentElement.classList.toggle(className, manualOpen || visible(modal));
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }
  function init() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest(openSelector)) {
        manualOpen = true;
        document.documentElement.classList.add(className);
      } else if (target.closest(closeSelector)) {
        manualOpen = false;
        document.documentElement.classList.remove(className);
      }
    }, true);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        manualOpen = false;
        document.documentElement.classList.remove(className);
      }
    }, true);
    new MutationObserver(queue).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden']
    });
    update();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else init();
}());